<template>
<v-layout row wrap>
    <v-flex xs6 >
        <v-autocomplete
          v-bind:items="hourSlots(minStartTime,'23:45', periodInMins)"
          v-model="startTime"
          label="Start time" />
    </v-flex>
    <v-flex xs6 >
        <v-autocomplete
          v-bind:items="hourSlots(startTime || minStartTime,'23:45', periodInMins)"
          v-model="endTime"
          label="End time" />
    </v-flex>
</v-layout>
</template>
<script>
import moment from 'moment'

export default {
  moment,
  name: 'OperatingHours',
  props: {
    minStartTime: { type: String, default: '01:00' },
    initialStartTime: { type: String, default: null, required: false },
    initialEndTime: { type: String, default: null, required: false },
    initialPeriodInMins: { type: Number, default: 30, required: false },
    periodInMins: { type: Number, default: 15, required: false },
    value: { type: String, default: '' }
  },
  data () {
    return {
      startTime: null,
      endTime: null
    }
  },
  methods: {
    toMoment (timeString) {
      return moment('2017-11-20 ' + timeString)
    },
    hourSlots (min, max, periodInMins) {
      /* example: min=08:00, max=17:00 */
      let start = moment('2017-11-20 ' + min)
      let end = moment('2017-11-20 ' + max)
      let time = start
      let times = [time.format('HH:mm')]
      if (time && end && periodInMins && periodInMins > 0 && time.isBefore(end)) {
        while (time.isBefore(end)) {
          time = moment(time.add(periodInMins, 'minutes'))
          times.push(time.format('HH:mm'))
        }
      }
      return times
    }
  },
  computed: {
    timeRange () {
      if (this.startTime && this.endTime) {
        return `${this.startTime}-${this.endTime}`
      }
      return null
    }
  },
  watch: {
    timeRange () {
      if (this.timeRange) {
        this.$emit('input', this.timeRange)
      }
    },
    initialStartTime () {
      this.startTime = this.initialStartTime
    },
    initialEndTime () {
      this.endTime = this.initialEndTime
    },
    initialPeriodInMins () {
      this.periodInMins = this.initialPeriodInMins
    },
    startTime () {
      let startMoment = this.toMoment(this.startTime)
      let endMoment = this.toMoment(this.endTime)
      if (startMoment.isSameOrAfter(endMoment)) {
        this.endTime = this.startTime
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// TimeRangePicker.vue?216ce00b